module.exports = __webpack_public_path__ + "media/images/back-arrow-1011967a18b02ddf028db8d2990f85d5.svg";